import {Component, Input, Output, EventEmitter} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'modal-component',
  template: require('./modal.component.html'),
  styles: [require('./modal.component.scss')]
})
export class ModalComponent {
  closeResult: boolean;
  @Input('title') title: any;
  @Output() result = new EventEmitter();

  constructor(private service: NgbModal) {}

  close(res: boolean) {
    this.result.next(res);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/modal/modal.component.ts